module.exports = __webpack_public_path__ + "img/img_polaroid_quilt05@3x.e4427286.png";